var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7026 0.999976L12.9997 0.297082C12.8045 0.10182 12.4879 0.10182 12.2926 0.297082L6.99974 5.58994L1.70684 0.297081C1.51158 0.101819 1.195 0.101819 0.999736 0.297081L0.296842 0.999975C0.10158 1.19524 0.10158 1.51182 0.296842 1.70708L5.58974 6.99994L0.296847 12.2929C0.101585 12.4881 0.101585 12.8047 0.296847 13L0.999741 13.7029C1.195 13.8981 1.51158 13.8981 1.70685 13.7029L6.99974 8.40994L12.2926 13.7028C12.4879 13.8981 12.8045 13.8981 12.9997 13.7028L13.7026 12.9999C13.8979 12.8047 13.8979 12.4881 13.7026 12.2928L8.40973 6.99994L13.7026 1.70708C13.8979 1.51182 13.8979 1.19524 13.7026 0.999976Z",
    fill: "#697377"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.bdc34696.svg";
export { ForwardRef as ReactComponent };